import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMercedesComponent } from './simple-icons-mercedes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMercedesComponent ],
    exports:      [ SimpleIconsMercedesComponent ],
    bootstrap:    []
})
export class SimpleIconsMercedesModule {}
